import { useEffect, useRef } from 'preact/hooks';
import css from './QtyWidget.module.css';

/**
 * Контрол количества с минус/плюс и ручным вводом. Кламп по [0, max].
 */
export function QtyWidget({ value, max = 999, onChange, disabled }) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && document.activeElement !== inputRef.current) {
      inputRef.current.value = value > 0 ? String(value) : '';
    }
  }, [value]);

  function emit(next) {
    if (disabled) return;
    const clamped = Math.max(0, Math.min(max, next));
    if (clamped !== value) onChange?.(clamped);
  }

  return (
    <div class={css.widget}>
      <button
        type="button"
        class={css.btn}
        onClick={() => emit(value - 1)}
        disabled={disabled || value <= 0}
        aria-label="Уменьшить"
      >
        −
      </button>
      <input
        ref={inputRef}
        type="text"
        inputMode="numeric"
        placeholder="0"
        class={css.input}
        disabled={disabled}
        defaultValue={value > 0 ? String(value) : ''}
        onInput={(e) => {
          e.target.value = e.target.value.replace(/\D/g, '');
          const next = parseInt(e.target.value, 10) || 0;
          emit(next);
        }}
        aria-label="Количество"
      />
      <button
        type="button"
        class={css.btn}
        onClick={() => emit(value + 1)}
        disabled={disabled || value >= max}
        aria-label="Увеличить"
      >
        +
      </button>
    </div>
  );
}
